module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-template"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10 col-lg-push-2 col-lg-8 pd-0"
  }, [_c('progress-step', {
    attrs: {
      "steps": ['1 สร้างเพจ', '2 เข้าสู่ระบบ', '3 บริจาค'],
      "active": _vm.step
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container pd-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10 col-lg-push-2 col-lg-8 pd-0"
  }, [_c('div', {
    staticClass: "_bg-graphic"
  }, [_c('div', {
    staticClass: "block shadow"
  }, [_c('div', {
    staticClass: "text-center mb-20"
  }, [_vm._v("คุณสามารถสร้างเพจระดมเงินเนื่องในโอกาสพิเศษของคุณหรือของเพื่อนได้ เพื่อส่งต่อความปรารถนาดีและร่วมให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน ")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper--pageform"
  }, [_c('card', {
    ref: "card",
    attrs: {
      "type": _vm.form.type,
      "name": _vm.form.name,
      "date": _vm.date,
      "custom-title": _vm.form.custom_type,
      "top-image": _vm.form.top_image,
      "bottom-image": _vm.form.bottom_image,
      "avatar-image": _vm.form.avatar_image,
      "editing": _vm.editing
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-push-3"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showRegisterForm) ? _c('div', {}, [_c('page-register-form', {
    on: {
      "submit": _vm.registerComplete,
      "cancel": _vm.cancelRegisterForm
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.showRegisterForm) ? _c('div', {}, [_c('page-form', {
    on: {
      "submit": _vm.submit
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1) : _vm._e()])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "campaign-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("สร้างเพจระดมเงินบริจาค")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("เพื่อร่วมบริจาคในโอกาสพิเศษของคุณหรือเพื่อนของคุณ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63e53f2c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/special-events/create.vue
// module id = 1171
// module chunks = 0